import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export default class UserFavoritesRepository extends Repository {
  getFavorites({userId}) {
    throw new Error('[FavoritesRepository#getFavorites] must be implemented')
  }

  removeFavorite({adId, userId}) {
    throw new Error('[FavoritesRepository#removeFavorite] must be implemented')
  }

  addFavorite({adId, userId}) {
    throw new Error('[FavoritesRepository#addFavorite] must be implemented')
  }
}
